import { colors, screen } from 'components/styles/variables';

export default `
  .dot-list {
    position: static;
    margin-top: 14px;
    overflow-x: scroll;
  }
  .custom-dot {
    width: 113px;
    height: 64px;
    padding: 0;
    border-radius: 8px;  
    margin: 0 8px;
    border: 0px;
  }
  .dot-image {
    width: 113px;
    height: 64px;
    object-fit: cover;
    border-radius: 8px;
  }
  .active .dot-image {
    border: 2px solid ${colors.BLACK};
  }
  .react-multi-carousel-dot-list {
    justify-content: flex-start;
  }
  @media (min-width: ${screen.smMin}) {
    .dot-list {
      margin-top: 24px;
      overflow-x: initial;
    }
    .custom-dot {
      width: 142px;
      height: 80px;
    }
    .dot-image {
      width: 142px;
      height: 80px;
      object-fit: cover;
      border-radius: 8px;
    }
    .react-multi-carousel-dot-list {
      justify-content: center;
    }
  }
  @media (min-width: ${screen.mdMin}) and (max-width: ${screen.mdMax}) {
    .custom-dot {
      width: 114px;
      height: 63px;
    }
    .dot-image {
      width: 114px;
      height: 63px;
      object-fit: cover;
      border-radius: 8px;
    }
  }
  @media (min-width: ${screen.lgMin}) {
    .custom-dot {
      width: 142px;
      height: 80px;
    }
    .dot-image {
      width: 142px;
      height: 80px;
      object-fit: cover;
      border-radius: 8px;
    }
  }
`;
